import Debug from '@/util/debug';
import FormInput from '@/components/form-input/FormInput.vue';

const debug = Debug('facebook-page-creation');

export default {
  props: {
    hasFacebookPage: Boolean,
    creationMode: [String, null],
    extraCostFacebookPage: Number,
  },
  dependencies: [
    'facebookPageService',
  ],
  components: {
    'form-input': FormInput,
  },
  data() {
    return {
      loading: true,
      clickedOk: false,
      localHasFacebookPage: this.hasFacebookPage,
      localCreationMode: this.creationMode,
      localExtraCostFacebookPage: this.extraCostFacebookPage,
      modes: [],
      defaultMode: null,
    };
  },
  mounted() {
    this.$root.$on('hidden::modal', () => {
      if (!this.clickedOk) {
        this.cancel();
      }
      this.clickedOk = false; // Reset click
    });
    const fin = () => {
      debug.info('finished loading. error: %o', this.error);
      this.loading = false;
    };

    Promise.all([
      this.facebookPageService.getDefaultCreationMode().then(mode => this.defaultMode = mode),
      this.facebookPageService.getCreationModes().then(res => this.modes = res),
    ])
    .then(fin)
    .catch(e => { this.error = e; fin(); });
  },
  computed: {
    optionsTrans() {
      const res = [];
      res.push({ text: this.$t('terms.misc.yes'), value: true });
      let noText = this.$t('terms.misc.no');
      if (this.creationMode && this.modes.length > 1) {
        noText += ', ';
        noText += this.$t('draft_field.format.facebook-page-mode', { mode: this.creationMode });
      }
      res.push({ text: noText, value: false });
      return res;
    },
    modesTrans() {
      return this.modes.map(mode => {
        let header = this.$t('draft_field.format.facebook-page-mode', { mode: mode.value });
        if (mode.cost > 0) {
          header += ` ${this.$t('draft_field.format.facebook-page-extracost', { cost: mode.cost })}`;
        }
        mode.header = header;
        mode.text = this.$t('pos.settings.facebook-page-mode.item', { value: mode.value, price: mode.cost });
        return mode;
      });
    },
  },
  methods: {
    confirm() {
      this.clickedOk = true;
      const mode = this.modes.find(m => m.value === this.localCreationMode);
      const cost = mode ? mode.cost : 0;
      if (cost > 0) {
        this.extraCostFacebookPage = cost;
        this.$emit('update:extraCostFacebookPage', this.extraCostFacebookPage);
      } else {
        this.clearDetails();
      }
      this.$emit('update:creationMode', this.localCreationMode);
    },
    cancel() {
      this.localHasFacebookPage = true;
      this.clearDetails();
    },
    clearDetails() {
      delete this.extraCostFacebookPage;
      this.$emit('update:extraCostFacebookPage', undefined);
    },
    closeModal() {
      if (this.$refs.creationModeModal) {
        this.$refs.creationModeModal.hide();
      }
    },
    setLocalMode(mode) {
      this.localCreationMode = mode;
    },
  },
  watch: {
    localHasFacebookPage: function watchHasFacebookPage(after) {
      this.$emit('update:hasFacebookPage', after);
      if (!after) {
        const idx = this.modes.findIndex(m => m.value === this.localCreationMode);
        if (idx === -1) {
          this.localCreationMode = this.defaultMode;
        }
        if (this.modes.length > 1) {
          this.$refs.creationModeModal.show();
        } else {
          this.localCreationMode = 'no-page';
          this.confirm();
        }
      } else {
        this.localCreationMode = this.defaultMode;
        this.$emit('update:creationMode', null);
        this.clearDetails();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/facebook-page-creation/FacebookPageCreation.js